import { completionEvent } from "../lib/completion-analytics";
import { useState } from "react";
import { Link } from "react-router-dom";
import type { SeatCandidate } from "@anjabom/core";
import { contributionRequest, seatKey } from "../lib/contribution-client";
import { isAppsInTossChannel } from "../lib/channel";
export function CreatePoll({
	candidates,
	showTitle,
}: {
	candidates: SeatCandidate[];
	showTitle: string;
}) {
	const [id, setId] = useState(""),
		[message, setMessage] = useState("");
	if (isAppsInTossChannel()) return null;
	async function create() {
		try {
			const result = await contributionRequest<{ id: string }>(
				"/api/polls",
				"POST",
				{
					candidates: candidates.map((seat) => ({
						seatKey: seatKey(seat),
						label: `${seat.venueName} ${seat.sectionCode} ${seat.rowLabel}열 ${seat.seatNumber}번`,
						expectedPrice: seat.expectedPrice,
					})),
					showTitle,
				},
			);
			setId(result.id);
			completionEvent("share_completed", { method: "poll" });
			const url = `https://anjabom.com/p/${result.id}`;
			setMessage("투표 링크를 만들었어요. 아래 링크를 일행에게 보내 주세요.");
			try {
				if (navigator.share) {
					await navigator.share({ title: "좌석 골라 주세요", url });
					setMessage("투표 링크를 공유했어요.");
				} else if (navigator.clipboard?.writeText) {
					await navigator.clipboard.writeText(url);
					setMessage("투표 링크를 복사했어요. 일행에게 붙여 넣어 보내 주세요.");
				}
			} catch (error) {
				setMessage(error instanceof DOMException && error.name === 'AbortError'
					? '공유를 취소했어요. 투표는 만들어졌고 아래 링크로 다시 보낼 수 있어요.'
					: '투표 링크를 만들었어요. 자동으로 복사하지 못해 아래 링크를 직접 복사해 주세요.');
			}
		} catch (e) {
			setMessage(e instanceof Error ? e.message : "연결되면 다시 눌러 주세요.");
		}
	}
	return (
		<section className="stack">
			<h2>일행에게 고르게 해요</h2>
			<p>이름 없이 한 표씩 골라요. 무료 투표는 동시에 하나, 3일 동안 열려요.</p>
			<button
				type="button"
				className="button"
				disabled={candidates.length < 2}
				onClick={() => void create()}
			>
				일행에게 고르게 하기
			</button>
			{id ? (
				<>
					<Link to={`/p/${id}`}>투표 결과 보기</Link>
					<label className="field">
						직접 복사할 링크
						<input
							className="input"
							readOnly
							value={`https://anjabom.com/p/${id}`}
							onFocus={(e) => e.target.select()}
						/>
					</label>
				</>
			) : null}
			<p role="status">{message}</p>
			{message.includes("동시에 하나") ? (
				<Link to="/pass?trigger=poll_limit">시즌 패스 안내 보기</Link>
			) : null}
		</section>
	);
}
